<template>
    <form ref="SLO_IF">
        <input type="hidden" name="SLO_P_OTA">
        <input type="hidden" name="j_slo_p_ota" value="">
        <input type="hidden" name="rmode" value="2">
        <input type="hidden" name="returnURL" value="">
        <input type="hidden" name="isAdUser" value="false">
        <input type="hidden" name="slo_ota_id" value="">
        <input type="hidden" name="slo_ota_pnum" value="">
        <input type="hidden" name="slo_ota_cnum" value="">
    </form>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
    data() {
    },
    created() {
        this.createSharePoint();
    },
    methods: {
        ...mapActions("restAction", ["COWORK_REST_ACTION"]),
        createSharePoint() {
            let obj = this;
            let reqData = {};
            reqData.req = this.req;
            reqData.method = "post";
            reqData.url = "/api/auth/slo/reverseSloSp";
            this.COWORK_REST_ACTION(reqData)
                .then(function(res) {                    
                    if (res.result.otaPnum) {
                        console.log("COWORK##################################");
                        obj.$refs.SLO_IF.slo_ota_id.value = res.result.otaId;
                        obj.$refs.SLO_IF.slo_ota_pnum.value = res.result.otaPnum;
                        obj.$refs.SLO_IF.slo_ota_cnum.value = res.result.otaCnum;
                        console.log(obj.$refs.SLO_IF.slo_ota_id.value);
                        console.log(obj.$refs.SLO_IF.slo_ota_pnum.value);
                        console.log(obj.$refs.SLO_IF.slo_ota_cnum.value);
                    } else {
                        console.log("SLO##################################");
                        obj.$refs.SLO_IF.j_slo_p_ota.value = res.result.otaId;
                    }
                    obj.$refs.SLO_IF.method = 'POST';
                    obj.$refs.SLO_IF.action = obj.$route.query.returnURL;
                    obj.$refs.SLO_IF.submit();
                })
                .catch(function(err) {
                    console.log(err);
                });
        },
    }
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/slo/GoSharePoint.vue